import React from 'react'
import PropTypes from 'prop-types'
import {Spin} from 'antd'
import BatchRow from './BatchRow'
import '../../styles/index.scss'

const PackagedTable = (props) => {

    const {loading, listBatches, adminRole} = props

    const onChangeProductType = (value) => {
        const {onChangeFilters} = props

        onChangeFilters && onChangeFilters({'products': value})
    }

    return (
        <div className='BatchesPageContainer'>
            <Spin spinning={loading} tip='Đang tải...'>
                <table className='table table-borderless table-striped'>
                    <thead className='thead-light'>
                    <tr>
                        <th className='Name'>Tên lô</th>
                        <th className="CreatedAt">Ngày tạo</th>
                        <th className="Products">Loại sản phẩm</th>
                        {adminRole &&
                            <th className="ItemCount">Số items đóng gói</th>
                        }
                        <th className="User">Người đóng gói</th>
                        <th className="PrintingPartner">Đối tác in-ép</th>
                        <th className="SewingParter">Đối tác may</th>
                        <th className="PackagedAt">Thời gian đóng gói</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        listBatches.length > 0 ? (
                            listBatches.map((item, index) => {
                                    return (
                                        <BatchRow 
                                            item={item}
                                            onChangeProductType={onChangeProductType}
                                            key={index}
                                            adminRole={adminRole}
                                        />
                                    )
                                }
                            )
                        ) : (
                            <tr>
                                <td colSpan={8}>Không có dữ liệu</td>
                            </tr>
                        )
                    }
                    </tbody>
                </table>
            </Spin>
        </div>
    )

}

PackagedTable.propTypes = {
    listBatches: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    onChangeProductType: PropTypes.func
}

export default PackagedTable
